import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Carrito() {
  const productosCarrito = useSelector((state) => state.cart);
  const totalItems = productosCarrito.cart.length;

  return (
    <Link
      to="/cotizaciones"
      aria-label="Ver mi cotización"
      title="Mi cotización"
      className="relative flex items-center justify-center hover:bg-white/10 transition-colors duration-200 p-2.5 rounded-lg"
    >
      {totalItems > 0 && (
        <span className="absolute -top-1.5 -right-1.5 z-20 bg-[#00BEE7] text-[#0f274b] rounded-full h-5 w-5 flex justify-center items-center font-black text-[10px] shadow pointer-events-none">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    </Link>
  );
}

export default Carrito;
